import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import './SignStatus.scss';
import { Button, Text } from '../../../../../Common';
import { setAssetSigantures } from '../../../../../../redux/actions/createHPoolActions';
import { createNotification } from '../../../../../../redux/actions/uiActions';
import { useAssetsSignatures } from '../../../../../../hooks/useAssetsSignatures';

const SignStatus = ({
  tokenId,
  token,
  isExecuted,
  assetSignatures,
  loading,
  signatureType,
  hpool,
  signMethod,
  ...rest
}) => {
  const [, , isInAssetSignature] = useAssetsSignatures();
  const signTx = async () => {
    const signFunc = signMethod;
    signFunc(token);
  };

  const isSigned = isInAssetSignature(tokenId);
  return (
    <>
      {isSigned ? (
        <Text text="hpool.signed" className="text-green font-reg font-light" />
      ) : (
        <Button
          className="button green sign-btn font-reg"
          onClick={signTx}
          text="hpool.sign_tx"
          loadingText="hpool.signing_tx"
          loading={loading === tokenId}
          disabled={!!loading}
          requireWallet
          requireChampWallet
          // {...rest}
        />
      )}
    </>
  );
};

SignStatus.defaultProps = {
  assetSignatures: {},
  isExecuted: null,
  signMethod: null,
  loading: false,
  signatureType: null,
};

SignStatus.propTypes = {
  tokenId: PropTypes.number.isRequired,
  isExecuted: PropTypes.bool,
  loading: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  signatureType: PropTypes.string,
  assetSignatures: PropTypes.object,
  token: PropTypes.object.isRequired,
  hpool: PropTypes.object.isRequired,
  signMethod: PropTypes.func,
};

const mapStateToProps = ({ createHPool }) => ({
  assetSignatures: createHPool.assetSignatures,
  hPoolId: createHPool.hpool.id,
  hpool: createHPool.hpool,
});

export default connect(mapStateToProps, { setAssetSigantures, createNotification })(SignStatus);
